import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, map, Observable, of, Subject } from "rxjs";
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { IRouteMapRequest } from "../models/IRouteMapRequest";
import { environment } from '../../../../../../environments/environment';
import { ILocationDTO } from "../models/GeoPosLocations/IGetLastGeoJson";
import { RouteMapAPIService } from "../../../../shared/services/API/RouteMapAPI.service";
@Injectable({
  providedIn: "root",
})
export class RouteFilterService {
  
  mapboxToken: string;
  configUrl: string;
  isVisiblePanel$: Subject<boolean> = new Subject<boolean>();
  vehiculo$: Subject<string> = new Subject<string>();

  constructor(private http: HttpClient, private router: Router, private routeMapApiService: RouteMapAPIService) {
    this.configUrl = environment.host;
    this.mapboxToken = environment.mapBoxToken;
  }

  getVisibilityPanel(): Observable<boolean> {
    return this.isVisiblePanel$.asObservable();
  }
  setVisibilityPanel(op) {
    this.isVisiblePanel$.next(op);
  }
  getVehiculo(): Observable<string> {
    return this.vehiculo$.asObservable();
  }
  setVehiculo(op: string) {
    this.vehiculo$.next(op);
  }
  getRouteMapGeoJson(routeMapRequest: IRouteMapRequest): any {
    return this.routeMapApiService.getRouteMapGeoJson(routeMapRequest);
  }
 

  getRealRouteMap(routeMapRequest: IRouteMapRequest): Observable<EstatusJSON> {
    return this.routeMapApiService.getRealRouteMap(routeMapRequest);
  }
  
  getRouteData ( routeMapRequest: IRouteMapRequest ): any {
    return this.routeMapApiService.getRouteData( routeMapRequest );
  }

  GetDirectionByCoords(latitude: any, longitude: any): any {
    return this.routeMapApiService.GetDirectionByCoords(latitude, longitude);
  }

  GetRouteDataList(): any {
    return this.routeMapApiService.GetRouteDataList();
  }

  GetDirection(x, y): Observable<string> {
    return this.GetDirectionByCoords(x, y).pipe(
      map((data: EstatusJSON) => data.isSuccess ? data.result : "Dirección no disponible"),
      catchError(error => {
        if(!environment.production) console.log("Servicio de Direcciones no disponible, inténtelo más tarde");
        return of("Dirección no disponible");
      })
    );
  }

  getDirectionsAPI(locations): any {
    let headers = new HttpHeaders().set('Access-Control-Allow-Origin', '*');
    if(!environment.production) console.log("https://api.mapbox.com/directions/v5/mapbox/driving/");
    return this.http.get<any>(
      "https://api.mapbox.com/directions/v5/mapbox/driving/" +
        locations +
        "?geometries=geojson&overview=full&access_token=" +
        this.mapboxToken,
      { headers: headers }
    );
  }

  
}
